<template>
  <div style="position: relative;">
    <el-form ref="flowRequirementList" :model="flowRequirementList" label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <filter-box :item-width="350">
        <el-form-item label="工单状态" prop="formFilter.flowStatus">
          <el-select class="filter-item" v-model="flowRequirementList.formFilter.flowStatus" :clearable="true"
            placeholder="工单状态">
            <el-option v-for="item in SysFlowWorkOrderStatus.getList()" :key="item.id"
              :label="item.name" :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期" prop="formFilter.createTime">
          <date-range class="filter-item" v-model="flowRequirementList.formFilter.createTime" :clearable="true" :allowTypes="['day']" align="left"
            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="工单编号" prop="formFilter.workOrderCode">
          <el-input class="filter-item" v-model="flowRequirementList.formFilter.workOrderCode"
            :clearable="true" placeholder="工单编号"
          />
        </el-form-item>
        <el-form-item label="创建人" prop="formFilter.createUserName">
          <el-input class="filter-item" v-model="flowRequirementList.formFilter.createUserName"
                    :clearable="true" placeholder="创建人名称"
          />
        </el-form-item>
        <el-form-item label="需求主题" prop="formFilter.queryForm.subjectName">
          <el-input class="filter-item" v-model="flowRequirementList.formFilter.queryForm.subjectName"
                    :clearable="true" placeholder="需求主题"
          />
        </el-form-item>
        <el-form-item label="需求类型" prop="formFilter.queryForm.subjectType">
          <el-select class="filter-item" v-model="flowRequirementList.formFilter.queryForm.subjectType" :clearable="true" filterable
                     placeholder="" :loading="flowRequirementList.subjectType.impl.loading"
                     @visible-change="flowRequirementList.subjectType.impl.onVisibleChange"
                     @change="onSubjectTypeValueChange">
            <el-option v-for="item in flowRequirementList.subjectType.impl.dropdownList" :key="item.id"
                       :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="地区" prop="formFilter.queryForm.areaId">
          <el-cascader class="filter-item"  v-model="flowRequirementList.areaId.value"
                       :options="flowRequirementList.areaId.impl.dropdownList" filterable
                       :clearable="true" :show-all-levels="false" placeholder="地区"
                       :props="{value: 'id', label: 'name'}"
                       @visible-change="flowRequirementList.areaId.impl.onVisibleChange"
                       @change="onAreaIdValueChange"
          />
        </el-form-item>
        <el-form-item label="对接状态" prop="formFilter.queryForm.isDocking">
          <el-select class="filter-item" v-model="flowRequirementList.formFilter.queryForm.isDocking" :clearable="true" filterable
                     placeholder="" :loading="flowRequirementList.isDocking.impl.loading"
                     @visible-change="flowRequirementList.isDocking.impl.onVisibleChange"
          >
            <el-option v-for="item in flowRequirementList.isDocking.impl.dropdownList" :key="item.id"
                       :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否帮助上传" prop="formFilter.queryForm.isHelp">
          <el-select class="filter-item" v-model="flowRequirementList.formFilter.queryForm.isHelp" :clearable="true" filterable
                     placeholder="" :loading="flowRequirementList.isHelp.impl.loading"
                     @visible-change="flowRequirementList.isHelp.impl.onVisibleChange"
          >
            <el-option v-for="item in flowRequirementList.isHelp.impl.dropdownList" :key="item.id"
                       :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="流程状态" prop="formFilter.latestApprovalStatus">
          <el-select class="filter-item" v-model="flowRequirementList.formFilter.latestApprovalStatus"
                     :clearable="true" filterable
                     placeholder="" :loading="flowRequirementList.latestApprovalStatus.impl.loading"
                     @visible-change="flowRequirementList.latestApprovalStatus.impl.onVisibleChange"
          >
            <el-option v-for="item in flowRequirementList.latestApprovalStatus.impl.dropdownList" :key="item.id"
                       :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onReset">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshFlowRequirementList(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize"
          @click="onStartTaskClick()">
          新建
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="requirement" :data="requirementWidget.dataList" :size="defaultFormItemSize"
          @sort-change="requirementWidget.onSortChange"
          header-cell-class-name="table-header-gray">
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px"
            :index="requirementWidget.getTableIndex"
          />
          <el-table-column label="工单编号" prop="workOrderCode" />
          <el-table-column label="创建人" prop="userShowName" />
          <el-table-column label="需求主题" prop="masterData.subjectName">
          </el-table-column>
          <el-table-column label="需求类型" prop="masterData.subjectTypeDictMap.name">
          </el-table-column>
<!--          <el-table-column label="需求描述" prop="masterData.requirementDesc">-->
<!--          </el-table-column>-->
          <el-table-column label="需求主体名称" prop="masterData.mainBody">
          </el-table-column>
          <el-table-column label="需求主体手机" prop="masterData.mainPhone">
          </el-table-column>
<!--          <el-table-column label="有效期" prop="masterData.validityDictMap.name">-->
<!--          </el-table-column>-->
<!--          <el-table-column label="是否公开" prop="masterData.isOpenDictMap.name">-->
<!--          </el-table-column>-->
          <el-table-column label="当前任务" prop="runtimeTaskInfo.taskName" />
          <el-table-column label="流程创建时间" prop="createTime" />
          <el-table-column label="流程状态" prop="latestApprovalStatusDictMap.name" width="100px" />
          <el-table-column label="工单状态" prop="flowStatus"  width="100px">
            <template slot-scope="scope">
              <span>{{SysFlowWorkOrderStatus.getValue(scope.row.flowStatus)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150px" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" :size="defaultFormItemSize"
                v-if="(scope.row.initTaskInfo || {}).taskKey !== (scope.row.runtimeTaskInfo || {}).taskKey"
                @click.stop="onViewTaskClick(scope.row)">
                详情
              </el-button>
              <el-button type="text" :size="defaultFormItemSize"
                v-if="(scope.row.initTaskInfo || {}).taskKey === (scope.row.runtimeTaskInfo || {}).taskKey"
                @click.stop="onHandlerTaskClick(scope.row)">
                办理
              </el-button>
              <el-button type="text" :size="defaultFormItemSize" class="table-btn"
                @click.stop="onRemindClick(scope.row)">
                催办
              </el-button>
              <el-button type="text" :size="defaultFormItemSize" class="table-btn error"
                @click.stop="onCancelTaskClick(scope.row)">
                撤销
              </el-button>
              <el-button type="text" :size="defaultFormItemSize" class="table-btn error"
                         v-if="scope.row.masterData.auditStatus==='1'"
                         @click.stop="onRequirementFormClick(scope.row)">
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="requirementWidget.totalCount"
            :current-page="requirementWidget.currentPage"
            :page-size="requirementWidget.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="requirementWidget.onCurrentPageChange"
            @size-change="requirementWidget.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import '@/staticDict/flowStaticDict.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { RequirementRelateController, RequirementController, DictionaryController } from '@/api';
/* eslint-disable-next-line */
import { FlowOperationController } from '@/api/flowController.js';

const processDefinitionKey = 'flowRequirementAudit';
const processDefinitionName = '需求审核流程';

export default {
  name: 'flowRequirementList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      flowRequirementList: {
        formFilter: {
          flowStatus: undefined,
          workOrderCode: undefined,
          createTime: [],
          latestApprovalStatus: undefined,
          createUserName: undefined,
          queryForm: {}
        },
        formFilterCopy: {
          flowStatus: undefined,
          workOrderCode: undefined,
          createTime: [],
          latestApprovalStatus: undefined,
          createUserName: undefined,
          queryForm: {}
        },
        latestApprovalStatus: {
          impl: new DropdownWidget(this.loadLatestApprovalStatusDropdownList)
        },
        subjectType: {
          impl: new DropdownWidget(this.loadSubjectTypeDropdownList)
        },
        isDocking: {
          impl: new DropdownWidget(this.loadIsDockingDropdownList)
        },
        isHelp: {
          impl: new DropdownWidget(this.loadIsHelpDropdownList)
        },
        areaId: {
          impl: new DropdownWidget(this.loadAreaIdDropdownList, true, 'id', 'parentId'),
          value: []
        },

        isInit: false
      },
      requirementWidget: new TableWidget(this.loadRequirementData, this.loadRequirementVerify, true, false)
    }
  },
  methods: {
    onRequirementFormClick (row) {
      let params = {
        id: row.masterData.id
      };

      params.closeVisible = 1;
      this.$router.push({name: 'requirementForm', query: params});
    },

    onReset () {
      this.flowRequirementList.areaId.value = []
      this.$refs.flowRequirementList.resetFields();
      this.refreshFlowRequirementList(true);
    },
    loadLatestApprovalStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysLatestApprovalStatusDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadRequirementData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        flowWorkOrderDtoFilter: {
          flowStatus: this.flowRequirementList.formFilterCopy.flowStatus,
          workOrderCode: this.flowRequirementList.formFilterCopy.workOrderCode,
          queryForm: this.flowRequirementList.formFilterCopy.queryForm,
          latestApprovalStatus: this.flowRequirementList.formFilterCopy.latestApprovalStatus,
          createUserName: this.flowRequirementList.formFilterCopy.createUserName,
          createTimeStart: Array.isArray(this.flowRequirementList.formFilterCopy.createTime) ? this.flowRequirementList.formFilterCopy.createTime[0] : undefined,
          createTimeEnd: Array.isArray(this.flowRequirementList.formFilterCopy.createTime) ? this.flowRequirementList.formFilterCopy.createTime[1] : undefined
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        RequirementController.listWorkOrderFlowRequirementAudit(this, params).then(res => {
          let dataList = res.data.dataList.map(item => {
            item.initTaskInfo = JSON.parse(item.initTaskInfo);
            item.runtimeTaskInfo = Array.isArray(item.runtimeTaskInfoList) ? item.runtimeTaskInfoList[0] : undefined;
            item.masterData = item.masterData || {};
            return item;
          });
          resolve({
            dataList: dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        })
      });
    },
    loadRequirementVerify () {
      this.flowRequirementList.formFilterCopy.flowStatus = this.flowRequirementList.formFilter.flowStatus;
      this.flowRequirementList.formFilterCopy.workOrderCode = this.flowRequirementList.formFilter.workOrderCode;
      this.flowRequirementList.formFilterCopy.createTime = this.flowRequirementList.formFilter.createTime;
      this.flowRequirementList.formFilterCopy.queryForm = this.flowRequirementList.formFilter.queryForm;
      this.flowRequirementList.formFilterCopy.latestApprovalStatus = this.flowRequirementList.formFilter.latestApprovalStatus;
      this.flowRequirementList.formFilterCopy.createUserName = this.flowRequirementList.formFilter.createUserName;
      return true;
    },
    // 启动流程
    onStartTaskClick () {
      let params = {
        processDefinitionKey: processDefinitionKey
      }

      FlowOperationController.viewInitialTaskInfo(this, params).then(res => {
        if (res.data && res.data.taskType === this.SysFlowTaskType.USER_TASK && res.data.assignedMe) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              processDefinitionKey: processDefinitionKey,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: '启动流程',
              isDraft: true,
              flowEntryName: processDefinitionName,
              variableList: res.data.variableList,
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              })
            }
          });
        } else {
          FlowOperationController.startOnly(this, {
            processDefinitionKey: processDefinitionKey
          }).then(res => {
            this.$message.success('启动成功！');
          }).catch(e => {});
        }
      }).catch(e => {});
    },
    // 办理流程
    onHandlerTaskClick (row) {
      let taskId = (Array.isArray(row.runtimeTaskInfoList) && row.runtimeTaskInfoList.length > 0) ? row.runtimeTaskInfoList[0].taskId : undefined;
      let params = {
        processInstanceId: row.processInstanceId,
        processDefinitionId: row.processDefinitionId,
        taskId: taskId
      }

      FlowOperationController.viewRuntimeTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: true,
              isDraft: row.flowStatus === this.SysFlowWorkOrderStatus.DRAFT,
              taskId: taskId,
              processDefinitionKey: processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: (row.runtimeInitialTask || {}).taskName,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              }),
              variableList: res.data.variableList
            }
          });
        }
      }).catch(e => {});
    },
    // 查看流程
    onViewTaskClick (row) {
      let params = {
        processInstanceId: row.processInstanceId
      }
      let taskId = (Array.isArray(row.runtimeTaskInfoList) && row.runtimeTaskInfoList.length > 0) ? row.runtimeTaskInfoList[0].taskId : undefined;
      FlowOperationController.viewInitialHistoricTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: false,
              taskId: taskId,
              processDefinitionKey: row.processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              routerName: res.data.routerName,
              readOnly: true,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator
            }
          });
        }
      }).catch(e => {});
    },
    loadIsDockingDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIsDockingDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadIsHelpDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    onAreaIdValueChange (value) {
      this.flowRequirementList.formFilter.queryForm.areaId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
     * 地区id下拉数据获取函数
     */
    loadAreaIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAreaStreet(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 需求类型下拉数据获取函数
     */
    loadSubjectTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictRSTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 需求类型选中值改变
     */
    onSubjectTypeValueChange (value) {
    },
    // 催办
    onRemindClick (row) {
      FlowOperationController.remindRuntimeTask(this, {
        workOrderId: row.workOrderId
      }).then(res => {
        this.$message.success('催办成功');
      }).catch(e => {});
    },
    // 撤销流程
    onCancelTaskClick (row) {
      this.$confirm('是否撤销此工单？').then(res => {
        let params = {
          workOrderId: row.workOrderId,
          cancelReason: '主动撤销'
        }

        FlowOperationController.cancelWorkOrder(this, params).then(res => {
          this.$message.success('撤销成功！');
          this.refreshFlowRequirementList();
        }).catch(e => {});
      }).catch(e => {});
    },
    // 刷新工单
    refreshFlowRequirementList (reloadData = false) {
      if (reloadData) {
        this.requirementWidget.refreshTable(true, 1);
      } else {
        this.requirementWidget.refreshTable();
      }
      if (!this.flowRequirementList.isInit) {
        // 初始化下拉数据
      }
      this.flowRequirementList.isInit = true;
    },
    onResume () {
      this.refreshFlowRequirementList();
    },
    formInit () {
      this.refreshFlowRequirementList();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>

<style>
</style>
